import React from "react";
import { FormSectionElements, ProgramContainer } from "src/entities/formTemplateDataType";
import classNames from 'classnames';
import { LiveValidationErrMsg } from "../live-validation-errMsg/LiveValidationErrMsg";
import AddressSearchComponent, { Address } from "./AddressSearchComponent";
import { getRootComponent } from "../../utilities/ElementUtils";
import { getAddress, getCxpAddressString } from "../../utilities/addressUtils";


export interface CXPAddress {
  addressLine1: string;
  addressLine2?: string | null;
  streetSuffix?: string;
  city: string;
  province: string;
  postalCode: string;
  countryCode: string;
  nocVersion?: string | null;
  isDetailAddress?: boolean;
};

interface Props {
  field: FormSectionElements;
  editable: boolean;
  title;
  labelControlArray;
  requiredField;
  callbackElement: (programContainer: ProgramContainer)=> void;
  isEng: boolean;
}


export interface ErrorMessage {
  id: string;
  message: string;
}

interface State {
  errors: ErrorMessage[];
  address?: Address;
}

export class AddressComponent extends React.Component<Props, State> {
  static REQUIRED_LABEL_ENGLISH = "Required"  
  static REQUIRED_LABEL_FRENCH = 'Obligatorie';
  profile = this.props.field.parent.parent.parent.Profile;

  constructor(props: Props) {
    super(props);
   
    this.state = {
      errors: [],
      address: undefined,
    };

    this.props.field.Touched=false;
    this.props.field.Valid=true;
  }

  setFieldValue = (value: string) => {
    this.props.field.Value=value;
    if (this.props.field.Optional !== 'Y') {
      this.props.field.Valid = !!value;
    }
    this.props.field.Touched = true;
    this.props.field.IsEmpty = !value;
    if (value) {
      this.props.field.ErrorMessage = '';
      this.props.field.EmptyErrorMessageFRA = '';
    }
  }

  setFieldValid = (valid: boolean) => {
    this.props.field.Valid = valid;
  }

  setValidationErrorMessage = (errors: ErrorMessage[]) => {
    const message = errors.reduce((sum, error) => {
      sum += error.message + '\n';
      return sum;
    }, '');
    this.props.field.ErrorMessage = message
    this.props.field.EmptyErrorMessageFRA = message
  }

  setFieldAddress = (address: Address) => {
    this.props.field.Address = address;
    // if (!this.props.field.addressType || this.props.field.addressType === 'Residential') { 
    //   const root = getRootComponent(this.props.field);
    //   root.Profile = {...root.Profile ?? {}, address: address};
    // }
  };

  setSameAsResidential = (value: boolean) => {
    this.props.field.mailingSameAsResidential = value;
  }

  getToken = () => {
    const root = getRootComponent(this.props.field);
    // console.log('address token', root.Profile?.token);
    return root.Profile?.token;
  }

  render() {
     let field = this.props.field;
    
    const displayfield: boolean = true;
    let editable = this.props.editable;
    let labelControlArray = this.props.labelControlArray;
    let requiredField = this.props.requiredField;
    let controlArray = [];
    let title = this.props.title;

    field.Value = getAddress(field.Address) || getCxpAddressString(field.parent.parent.parent.Profile?.address);
 
     if (displayfield) {
      if (editable) {

        controlArray.push(<>
          <div className="ontario-form-group" key={'fdIpt_div_address_' + this.props.field.Id} style={{ zIndex: 10 }}>
            <div key={'fdLbl_div_' + this.props.field.Id} >
              {labelControlArray}
            </div>

            {(this.props.field.ErrorMessage || this.props.field.ErrorMessageFRA) && (
              <LiveValidationErrMsg
                field={this.props.field}
                isEng={this.props.isEng}
                key={"LiveValidationErrMsg_" + field.LoadBindName}
                id={`${field.LoadBindName}-${field.Id}`}
              />
            )}

            <div key={'fdIpt_div_search' + field.Id} >
              <AddressSearchComponent
                lang={this.props.isEng ? 'en' : 'fr'}
                fieldName="address"
                accessToken={this.getToken()}
                searchUrl={process.env.PC_LOOKUP_URL || this.props.field.AddressLookupUrl}
                setFieldValue={this.setFieldValue}
                setFieldValid={this.setFieldValid}
                setFieldAddress={this.setFieldAddress}
                setSameAsResidential={this.setSameAsResidential}
                setValidationErrorMessage={this.setValidationErrorMessage}
                field={this.props.field}
                callback={(element) => this.props.callbackElement(element)}
              />
            </div>
          </div>
       </>)
      } else {
        controlArray.push(
          <div className='pdf-two-column'>
            <div>{title}</div>
            <div className={classNames({ 'invalid-field--highlighted': (this.props.field.Value == '' || this.props.field.Value == null) && requiredField })} >{this.props.field.Value}</div>
          </div>
        );
      }
    }

    return controlArray;
  }
}